import { apiFetch } from '../utils/api';

export interface Bay {
    id: string;
    name: string;
    locationId: string;
    status: 'active' | 'inactive';
    location?: {
        id: string;
        name: string;
    };
}

export interface ListBaysResponse {
    data: Bay[];
    meta: {
        total: number;
        page: number;
        limit: number;
        totalPages: number;
    };
}

export const fetchBays = (params: { page?: number; limit?: number; search?: string; locationId?: string; status?: 'active' | 'inactive' } = {}) => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', String(params.page));
    if (params.limit) searchParams.set('limit', String(params.limit));
    if (params.search) searchParams.set('search', params.search);
    if (params.locationId) searchParams.set('locationId', params.locationId);
    if (params.status) searchParams.set('status', params.status);

    const query = searchParams.toString();
    return apiFetch<ListBaysResponse>(`/bays${query ? `?${query}` : ''}`);
};

